// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Icon from '@atlaskit/icon';

export const minimizeIcon = (props: ComponentProps<'svg'>) => (
	<svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="24" height="24" fill="white" fillOpacity="0" />
		<path
			d="M18.6667 16C19.403 16 20 16.4477 20 17C20 17.5128 19.4853 17.9355 18.8221 17.9933L18.6667 18H5.33333C4.59695 18 4 17.5523 4 17C4 16.4872 4.51474 16.0645 5.17786 16.0067L5.33333 16H18.6667Z"
			fill="currentColor"
		/>
	</svg>
);

type Props = {
	size?: 'small' | 'medium' | 'large' | 'xlarge';
	label: string;
	primaryColor?: string;
};

export const MinimizeIcon = (props: Props) => (
	<Icon
		glyph={minimizeIcon}
		// @ts-expect-error - TS2322 - Type '"small" | "medium" | "large" | "xlarge" | null' is not assignable to type 'Size | undefined'.
		size={props.size || null}
		label={props.label}
		primaryColor={props.primaryColor}
	/>
);
